module.exports = __webpack_public_path__ + "img/11.8c4fe2d0.png";